import Confetti from 'react-confetti';
import useWindowSize from 'src/app/hooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@mui/material';
import { useState } from 'react';

const BirthdayUzinfocomDialog = ({ isVisible, setIsVisible }) => {
  const { t, i18n } = useTranslation('translations');
  const { width, height } = useWindowSize();

  const lang = i18n.language;
  return (
    <Dialog fullScreen open={isVisible}>
      {/* Background Image */}
      <img
        src="assets/images/bday_cover.jpg"
        alt="Birthday Background"
        className="absolute inset-0 object-cover w-full h-full z-0"
      />

      {/* Confetti */}
      <div className="absolute inset-0 z-10 pointer-events-none">
        <Confetti width={width} height={height} numberOfPieces={300} />
      </div>

      {/* Content */}
      <div className="relative z-20 flex flex-col gap-4 items-center justify-center h-full px-4 mt-6 max-w-3xl mx-auto">
        <div className="bg-gradient-to-br from-gray-900 via-indigo-900 to-blue-900 backdrop-blur-md p-6 md:p-14 rounded-3xl shadow-lg w-full text-center space-y-6">
          <h1 className="text-3xl md:text-5xl font-bold text-yellow-300 drop-shadow-md">
            {lang === 'ru' ? '🎉 Нам — 23 года! 🎉' : '🎉 Bizga — 23 yosh! 🎉'}
          </h1>

          <p className="text-base md:text-lg text-blue-100 leading-relaxed">
            {lang === 'ru'
              ? `Сегодня UZINFOCOM отмечает свой День Рождения — уже 23 года мы вместе создаём цифровое
            будущее, развиваем технологии и делаем жизнь людей удобнее. 
                Но за каждой системой, каждым проектом и достижением — вы, наша команда! 
                Спасибо каждому за профессионализм, инициативу, идеи, поддержку и веру в общее дело. 
                Благодаря вашему труду и энергии UZINFOCOM — это больше, чем просто компания. 
                Это команда, это движение, это сила, которая меняет мир.`
              : `Bugun UZINFOCOM o‘z tug‘ilgan kunini nishonlamoqda — biz allaqachon 23 yildan beri birgalikda raqamli kelajakni yaratib, texnologiyalarni rivojlantirib, insonlar hayotini qulayroq qilishga hissa qo‘shib kelmoqdamiz.
              Har bir tizim, loyiha va yutug‘imiz ortida — siz, aziz jamoamiz.
Kasbiy mahoratingiz, tashabbusingiz, g‘oyalaringiz, yelkadoshligingiz va umumiy ishga bo‘lgan ishonchingiz uchun har biringizga chuqur minnatdorchilik bildiramiz.
Aynan sizlarning mehnatingiz va energiyangiz tufayli UZINFOCOM — oddiy kompaniya emas, bu — jamoa, bu — harakat, bu — dunyoni o‘zgartiruvchi kuchdir.
`}
          </p>

          <p className="italic font-semibold text-xl md:text-2xl text-violet-300 text-blue-100">
            {lang == 'ru'
              ? 'С Днём Рождения, семья UZINFOCOM!'
              : 'Tug‘ilgan kuningiz bilan, UZINFOCOM oilasi!'}
          </p>
          <p className="text-base md:text-lg text-blue-100 leading-relaxed">
            {lang == 'ru'
              ? 'Вперёд — к новым задачам, открытиям и ещё более ярким вершинам.'
              : 'Oldinda esa — yangi vazifalar, kashfiyotlar va yanada yorqin cho‘qqilar kutmoqda.'}
          </p>
          <p className="text-right text-base md:text-lg font-semibold text-white italic">
            {lang == 'ru' ? ' — С уважением, Гимранов Э.' : 'Hurmat bilan, E.Gimranov'}
          </p>
          {/* Close Button */}
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="px-10 py-6 bg-white/80 hover:bg-white text-black font-semibold rounded-full shadow-lg transition self-end italic"
        >
          {t('Close')}
        </button>
      </div>
    </Dialog>
  );
};

export default BirthdayUzinfocomDialog;
